import { useState, useCallback } from "react";
import { Scanner } from "./components/Scanner.jsx";
import { clearResults } from "./lib/storage.js";
import { T } from "./lib/design.js";

export default function App() {
  // Bumping this key force-unmounts Scanner. Combined with clearResults(),
  // it's a guaranteed full reset — works even if Scanner is wedged.
  const [resetKey, setResetKey] = useState(0);
  const [fixing, setFixing] = useState(false);
  const [fixMessage, setFixMessage] = useState("");

  const handleFix = useCallback(async () => {
    setFixing(true);
    setFixMessage("Clearing all state and storage…");
    try {
      clearResults();
      await new Promise((r) => setTimeout(r, 250));
      setResetKey((k) => k + 1);
      setFixMessage("✓ Scanner reset. Click Run scan to start fresh.");
      setTimeout(() => setFixMessage(""), 4000);
    } catch (e) {
      setFixMessage("Reset attempted. Click Run scan to try again.");
      setResetKey((k) => k + 1);
      setTimeout(() => setFixMessage(""), 4000);
    } finally {
      setFixing(false);
    }
  }, []);

  return (
    <div>
      <Scanner key={resetKey} resetSignal={resetKey} />

      {/* Fail-safe Fix button — always accessible at bottom */}
      <div
        style={{
          marginTop: 24,
          padding: "16px 18px",
          background: "rgba(248,113,113,0.04)",
          border: "1px dashed rgba(248,113,113,0.35)",
          borderRadius: 12,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#dc2626", marginBottom: 3 }}>🛟 Fail-safe Fix</div>
            <div style={{ fontSize: 11.5, color: T.textSecondary, lineHeight: 1.5 }}>
              Use this if the scanner becomes unresponsive, shows no results, or won&apos;t re-run. Clears state and
              persisted data, then re-mounts the scanner fresh.
            </div>
          </div>
          <button
            onClick={handleFix}
            disabled={fixing}
            style={{
              fontSize: 12,
              padding: "8px 16px",
              borderRadius: 7,
              fontWeight: 700,
              border: "1px solid #dc2626",
              background: fixing ? "rgba(220,38,38,0.05)" : "rgba(220,38,38,0.1)",
              cursor: fixing ? "not-allowed" : "pointer",
              color: "#dc2626",
              whiteSpace: "nowrap",
            }}
          >
            {fixing ? "Fixing…" : "🛟 Fix scanner"}
          </button>
        </div>
        {fixMessage && (
          <div
            style={{
              marginTop: 10,
              padding: "6px 10px",
              fontSize: 11,
              background: "rgba(34,197,94,0.08)",
              border: "0.5px solid rgba(34,197,94,0.25)",
              color: "#16a34a",
              borderRadius: 6,
            }}
          >
            {fixMessage}
          </div>
        )}
      </div>

      <div
        style={{
          marginTop: 14,
          fontSize: 10.5,
          color: T.textMuted,
          lineHeight: 1.6,
          borderTop: `0.5px solid ${T.border}`,
          paddingTop: 12,
        }}
      >
        ⚠ For research and educational use only — not financial advice. Options involve substantial risk of loss. Data
        via AI-powered web search; verify quotes independently before trading.
      </div>
    </div>
  );
}
